import React from 'react'
import InputText from "../ReusableComponents/InputText";
import TextArea from "../ReusableComponents/TextArea";

const CancellationReasonPopup = ({ data }) => {

    if (!data) return null
  return (
    <div class="w-full ">
      <div class=" border-black  "></div>
      <div class="mx-auto flex justify-center lg:w-2/5 md:w-full w-full border-black">
        <div class="relative w-full h-full max-w-xl md:h-auto">
          <div class="relative bg-white rounded-lg shadow ">
            <div class="px-6 py-6 lg:px-8">
              <form class="space-y-6" action="#">
                <InputText
                  inputType={"text"}
                  classStar="text-red-500"
                  title={"Reason"}
                  name={"reason"}
                  content={data?.Reason || ""}
                  disabled="disabled"
                />
                <TextArea
                  inputType="text"
                  title="Description"
                  name="description"
                  rows="4"
                  disabled="disabled"
                  content={data?.Description||""}
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancellationReasonPopup
